import {Component, OnInit} from "@angular/core";
import {StromcheckRequestService} from "../services/request.service";
import {ActivatedRoute, Router} from "@angular/router";
import {ElementService} from "../../services/element.service";
import {PortalService} from "../../services/portal.service";
import {EmbedService} from "../../services/embed.service";
import {Step, Steps, StepService} from "../../services/step.service";
import {StromcheckAnfrage} from "../anfrage/stromcheck.anfrage";
import {EingabeForm} from "../eingabe/eingabe.form";
import {StepComponent} from "../../step/step.component";

/**
 * Component for entry on head stage for STC.
 */
@Component({
    selector: 'app-stromcheck-kopfbuehne',
    templateUrl: './kopfbuehne.component.html',
    standalone: false
})
export class KopfbuehneComponent extends StepComponent implements OnInit {

  /**
   * constructor
   * @param requestService
   * @param router
   * @param elementService
   * @param activatedroute
   * @param portalService
   * @param embedService
   * @param stepService
   */
  constructor(protected stepService: StepService, protected router: Router, protected requestService: StromcheckRequestService,
              protected elementService: ElementService, protected portalService: PortalService, protected activatedroute: ActivatedRoute, protected embedService: EmbedService) {
    super(stepService, router, elementService);
  }

  /**
   * the current userdata
   */
  anfrage: StromcheckAnfrage;

  /**
   * @inheritDoc
   */
  formConfig: EingabeForm;

  /**
   * target of the link of the headstage version
   */
  headstageVersionButtonUrl: string;

  /**
   * @inheritDoc
   */
  ngOnInit(): void {
    // add form
    this.formConfig = new EingabeForm();
    super.ngOnInit();

    //get the current and next step
    this.steps = new Steps();
    this.steps.currentStep = new Step('kopfbuehne', '');

    //add relevant form
    this.form = this.formConfig.getForm('kopfbuehne');

    // get the current input data and preset it
    this.anfrage = this.requestService.getAnfrage();
    this.formConfig.setData(this.anfrage.userInput);

    // url for headstage version
    this.activatedroute.data.subscribe(data => {
      // try to get button URL from the portal config, fallback to local URL if it is not there
      this.headstageVersionButtonUrl = this.portalService.getConfig('stromcheck.short.buttonlink');
      if (this.headstageVersionButtonUrl === null) {
        this.headstageVersionButtonUrl = this.router.url + '/../eingabe/start';
      }
    });

  }

  /**
   * save the selection of gebaeudetyp
   */
  saveData(): void {
    //get the data and merge with user input
    const data = this.formConfig.getData();
    this.anfrage.userInput = {...this.anfrage.userInput, ...data};

    // save data to local browser
    this.requestService.setAnfrage(this.anfrage);
    // save to server
    this.requestService.saveDataToServer();
  }

}
